import { API_BASE_URL } from '../config';

export async function loadClinicLogos() {
  const empty = { prescriptionLogo: null, headerLogo: null };
  const token = localStorage.getItem('token');
  if (!token) return empty;
  const response = await fetch(`${API_BASE_URL}/clinic/logo`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!response.ok) return empty;
  const data = await response.json();
  return {
    prescriptionLogo: data.prescriptionLogo || data.logo || null,
    headerLogo: data.headerLogo || null
  };
}

export async function loadClinicLogo() {
  const logos = await loadClinicLogos();
  return logos.prescriptionLogo;
}

export function pdfImageFormat(dataUrl) {
  const mime = String(dataUrl || '').slice(5, String(dataUrl || '').indexOf(';')).toLowerCase();
  if (mime === 'image/jpeg' || mime === 'image/jpg') return 'JPEG';
  if (mime === 'image/webp') return 'WEBP';
  return 'PNG';
}
